import { onboardingHelper } from './onboardingHelper'

export function teacherObsHelper() {
    return {
        teacherSteps(motpScore) {
            let steps = [
                {
                    intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                        <h2>WELCOME!</h2>
                        <p>Welcome to Growth Explorer! We aim to promote reflection and excellence in our public schools by encouraging you to:
                            <ul>
                                <li>View strengths and areas for personal growth both over time and by component</li>
                                <li>Foster a collaborative culture where feedback is easily accessible and actionable</li>
                            </ul>
                        </p>
                        <p>This tutorial will introduce you to the features that make Growth Explorer useful. Click <b>"Need Help?"</b> in the top right corner of the screen at any time to return to this tutorial.</p>`
                },
                {
                    intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                        <h2>OBSERVATION HISTORY</h2>
                        <p>Use this page to view which components were rated during your observations.</p>
                        <p>This can help you keep track of how your observations are progressing throughout the year.</p>`,
                    tooltipClass: 'hide-skip'
                },
                {
                    element: '#cards-display',
                    intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                        <h2>OBSERVATION HISTORY</h2>
                        <p>Click into an observation to view notes, score and rationale for each component rating. Try it now!</p>`,
                    tooltipClass: 'hide-skip'
                },
                {
                    element: '.grid-parent',
                    intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                        <h2>OBSERVATION HISTORY</h2>
                        <p>Use this graph to get an idea of how last year's MOTP score compares to the current school year thus far.</p>`,
                    tooltipClass: 'hide-skip',
                    highlightClass: 'thermobar'
                },
                {
                    element: '#teacher-dash-button',
                    intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                        <h2>OBSERVATION HISTORY</h2>
                        <p>Click here to quickly jump to your teacher dashboard.</p>`,
                    tooltipClass: 'hide-skip'
                },
                {
                    element: '#need-help',
                    intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                        <h2>OBSERVATION HISTORY</h2>
                        <p>If you ever need a reminder, find the tutorial for any page in Growth Explorer here.</p>`,
                    tooltipClass: 'last-step'
                }
            ]
            if (!motpScore) { steps.splice(3, 1) }
            return steps
        },
        adminSteps: [
            {
                intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                    <h2>OBSERVATION HISTORY</h2>
                    <p>Use the Observation History page to view which components were rated this school year. This can support you in sharing meaningful feedback that is coherent over time.</p>`
            },
            {
                element: '#cards-display',
                intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                    <h2>OBSERVATION HISTORY</h2>
                    <p>Click into an observation card for component evidence and additional evaluator notes.</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#cards-display',
                intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                    <h2>OBSERVATION HISTORY</h2>
                    <p>Use this information to help promote a purposeful and collaborative feedback cycle with other school staff.</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#need-help',
                intro: `${ onboardingHelper().closeIconText('doneTeacherObsOnboarding') }
                    <h2>OBSERVATION HISTORY</h2>
                    <p>If you ever need a reminder, find the tutorial for each page in Growth Explorer here.</p>`,
                tooltipClass: 'last-step'
            }
        ]
    }
}
